import { makeAutoObservable } from "mobx";
import { SvBook, SvLockerDetail, Reader } from "../../graphql";

export default function SessionStore() {
  return makeAutoObservable({
    // 除錯模式
    debug: false,
    // 語系
    locale: "zh-TW",
    // 是否已登入
    isAdmin: false,
    isLogin: false,
    userInfo: {} as Reader,
    // 錯誤訊息(含HTML)
    error: "",
    // 讀取條碼輸入
    privateInput: "",
    privateHandler: console.info,
    // 櫃子基本資料
    lockerDetail: [] as SvLockerDetail[],
    lockerTier: 0,
    lockerColumn: 0,
    lockerItems: new Map<number, SvBook>(),
    items: [] as SvBook[],
    takeitem: {} as SvBook,

    setLocker(
      lockerDetail: SvLockerDetail[],
      lockerTier: number,
      lockerColumn: number,
      items: SvBook[]
    ) {
      this.lockerDetail = lockerDetail;
      this.lockerTier = lockerTier;
      this.lockerColumn = lockerColumn;
      this.items = items;
      this.lockerItems.clear();
      items && items.forEach((item) => {
        if (item.locker_detail_id) {
          this.lockerItems.set(item.locker_detail_id, item);
        }
      });
    },

    reset() {
      // 除錯模式
      this.debug = false;
      // 語系
      this.locale = "zh-TW";
      // 是否已登入
      this.isAdmin = false;
      this.isLogin = false;
      this.userInfo = {} as Reader;
      // 錯誤訊息(含HTML)
      this.error = "";
      // 讀取條碼輸入
      this.privateInput = "";
      this.privateHandler = console.info;
      // 櫃子基本資料
      this.lockerDetail = [] as SvLockerDetail[];
      this.lockerTier = 0;
      this.lockerColumn = 0;
      this.lockerItems.clear();
      this.items = [] as SvBook[];
      this.takeitem = {} as SvBook;
    },
  });
}
